import mockedPaginatedResponse from './mockedPaginatedResponse';
import mockedRequester from './mockedRequester';
const mockedAPIKey = {
    id: 0,
    createdAt: '1623840436',
    key: 'fdjnskfdnsj67#2768',
    name: 'une clef de test'
};
const mock = {
    getMany: mockedRequester(mockedPaginatedResponse([mockedAPIKey]), 'api.getMany'),
    create: mockedRequester(mockedAPIKey, 'api.create'),
    delete: mockedRequester(undefined, 'api.delete')
};
export default mock;
